namespace SorAraBul.Administration {
    export namespace PermissionKeys {
        export const Security = "Administration:Security";
        export const Translation = "Administration:Translation";
        export const CompanyUser = "Administration:CompanyUser";
        export const CompanyAdmin = "Administration:CompanyAdmin";
        export const SuperAdmin = "Administration:SuperAdmin";
    }
}
